import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NbDialogService, NbLayoutScrollService } from "@nebular/theme";
import { replace, remove, clone, find } from "lodash";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";

import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import Announcement from "../../models/announcement.model";

import Bookmark from "../../models/bookmark.model";
import { WhereList } from "../../models/pagination";

import { BookmarkService } from "../../services/bookmark.service";

import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";

@Component({
  selector: "ngx-view-bookmarks",
  styleUrls: ["./view-bookmarks.component.scss"],
  templateUrl: "./view-bookmarks.component.html",
})
export class ViewBookmarksComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  @Input() mode?: string = "course";
  @Output() onClose: EventEmitter<any> = new EventEmitter();

  submitted = false;
  loading = false;

  firstData?: Bookmark[] = [];
  moreData?: Bookmark[] = [];
  bookmarks?: Bookmark[] = [];
  wheres: WhereList[] = [];

  uid = "anonymous";
  pageSize = 10;
  cursor: any;
  done = false;
  init = false;

  constructor(
    private bookmarkService: BookmarkService,
    public userService: UserService,
    private router: Router
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
        } else {
          this.uid = "";
        }
        this.getFirst();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getFirst(): void {
    this.loading = true;

    this.wheres = [];
    if (this.mode != "home") {
      this.wheres.push({
        fieldPath: "mode",
        value: this.mode,
      });
    }

    this.wheres.push({
      fieldPath: "createdBy",
      value: this.uid,
    });

    this.bookmarkService
      .getBookmarks(this.wheres, this.pageSize, null)
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            doc: c.payload.doc,
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        if (!this.cursor && data.length > 0) {
          this.cursor = data[data.length - 1].doc;
        } else {
          this.cursor = null;
          this.done = true;
        }

        data.forEach((com) => {
          com.createdOn = convertTimestamp(com.createdOn);
          com.updatedOn = convertTimestamp(com.updatedOn);
          this.getIconMode(com);

          let item = find(this.firstData, ["id", com.id]);
          if (item) {
            item = com;
          } else {
            if (this.init) {
              this.firstData = [com, ...this.firstData];
            } else {
              this.firstData.push(com);
            }
          }
        });

        this.bookmarks = [...this.firstData, ...this.moreData];
        this.loading = false;
        this.init = true;

        console.log("ViewBookmarksComponent/first:", this.bookmarks);
      });
  }

  loadMore() {
    this.pageSize = 12;
    this.loading = true;

    this.bookmarkService
      .getBookmarks(this.wheres, this.pageSize, this.cursor)
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
            doc: c.payload.doc,
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        if (data.length > 0) {
          this.cursor = data[data.length - 1].doc;
        } else {
          this.cursor = null;
          this.done = true;
        }

        data.forEach((com) => {
          com.createdOn = convertTimestamp(com.createdOn);
          com.updatedOn = convertTimestamp(com.updatedOn);
          this.getIconMode(com);

          let item = find(this.moreData, ["id", com.id]);
          if (item) {
            item = com;
          } else {
            this.moreData.push(com);
          }
        });

        this.bookmarks = [...this.firstData, ...this.moreData];
        this.loading = false;

        console.log("ViewBookmarksComponent/more:", this.moreData);
      });
  }

  navigateRef(item) {
    if (item.navigateUrl && item.navigateUrl.length > 0) {
      this.router.navigateByUrl(item.navigateUrl);
    }
  }

  onDelete(value) {
    if (value) {
      remove(this.bookmarks, (e) => {
        return e.id == value;
      });
    }
  }

  private getIconMode(data) {
    switch (data.mode) {
      case "courses":
        data.iconMode = "book-open-outline";
        data.navigateUrl = "/course/" + data.refId;
        data.preTitle = "khóa học";
        break;
      case "lecture-contents":
        data.iconMode = "file-text-outline";
        data.navigateUrl = "/lecture/" + data.refId;
        data.preTitle = "bài viết";
        break;
      case "exercises":
        data.iconMode = "award-outline";
        data.navigateUrl = "/exercise/" + data.refId;
        data.preTitle = "thử thách";
        break;
      case "qnas":
        data.iconMode = "question-mark-circle-outline";
        data.navigateUrl = "/qna/" + data.refId;
        data.preTitle = "câu hỏi";
        break;
      case "quizzes":
        data.iconMode = "layers-outline";
        data.navigateUrl = "/quiz/" + data.refId;
        data.preTitle = "câu đố";
        break;

      default:
        data.iconMode = "globe-outline";
        data.navigateUrl = "";
        data.preTitle = "";
        break;
    }
  }
}
